import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EliminarCertificadoCliente({
  registro = {},
  onClose = () => {},
  onDeleted = () => {},
}) {
  const [loading, setLoading] = useState(false);
  // ELIMINADO: const [error, setError] = useState("");

  const handleDelete = async () => {
    // ELIMINADO: setError("");
    setLoading(true);

    try {
      const id = registro.id;
      if (!id) throw new Error("ID de registro no encontrado.");

      const url = apiRoutes.certificadoCliente.deleteUrl(id);
      
      // Usamos POST según tu Controller
      await appFetchJson(url, { method: "POST" });

      onDeleted();
      onClose();
    } catch (e) {
      console.error(e);
      // ELIMINADO: Lógica de mensajes de error local.
      // Dejamos que el sistema global maneje la alerta.
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      {/* HEADER */}
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">Eliminar Cliente de Certificado</h2>
      </div>

      {/* BODY */}
      <div className="px-6 pt-4">
        {/* Mensaje de confirmación azul */}
        <div className="mb-4 px-4 py-3 text-blue-600">
          <span className="text-base font-medium">
             ¿Está seguro que desea eliminar esta asignación?
          </span>
          <br/>
          <span className="text-sm italic opacity-90"> 
            Nota: Esto podría recalcular el consumo de productos en el certificado.
          </span>
        </div>

        {/* Resumen de datos a eliminar (Estilo tarjeta gris) */}
        <div className="bg-gray-50 px-6 py-6 mb-2 space-y-3">
          <div className="flex flex-col">
            <span className="text-gray-500 text-xs uppercase tracking-wider font-semibold">Certificado</span>
            <span className="font-medium text-gray-800 text-lg">
                {registro.certificadoNumero ?? "—"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="text-gray-500 text-xs uppercase tracking-wider font-semibold">Cliente</span>
            <span className="font-medium text-gray-800 text-lg">
                {registro.clienteNombre ?? "—"}
            </span>
          </div>
        </div>
        
        {/* ELIMINADO: Bloque que renderizaba el error rojo local */}
      </div>

      {/* FOOTER */}
      <div className="px-6 py-4 border-t flex gap-2 modal-footer">
        <button 
            className="btn-fil" 
            onClick={handleDelete} 
            disabled={loading}
        >
          {loading ? "Eliminando..." : "Eliminar"}
        </button>

        <button 
            className="btn-fil" 
            onClick={onClose}
            disabled={loading}
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}